import { alpha, Theme } from "@mui/material";
import { grey } from "@mui/material/colors";

const ComponentOverrides: any = (theme: Theme) => {
  return {
    MuiToolbar: {
      styleOverrides: {
        root: {
          "@media (min-width:600px)": {
            minHeight: "59px",
          },
        },
      },
    },
    MuiButton: {
      disableElevation: true,
      styleOverrides: {
        root: {
          boxShadow: "none",
          textTransform: "capitalize",
          fontSize: "0.875rem",
          "&:hover": {
            boxShadow: "none",
          },
          "&.Mui-disabled": {
            backgroundColor: "grey[100]",
          },
        },
      },
    },
    // Checkbox
    MuiCheckbox: {
      styleOverrides: {
        root: {
          ".MuiSvgIcon-root": {
            fontSize: "1.375rem",
          },
        },
      },
    },

    //Radio
    MuiRadio: {
      styleOverrides: {
        root: {
          ".MuiSvgIcon-root": {
            fontSize: "1.375rem",
          },
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
        paper: {
          // borderColor: theme.palette.grey[100],
          // borderStyle: "solid",
          // borderWidth: 1,
          boxShadow: "0px 13px 16px 0px #0000000A",
        },
        list: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 8,
          padding: "5px 10px",
          boxShadow: "0px 1px 3px 0px #00000080",
          backgroundColor: theme.palette.common.white,
          color: grey[800],
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          ".MuiInputBase-root": {
            ".MuiInputBase-input.MuiOutlinedInput-input": {
              padding: "8.5px 10px",
            },
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontsize: "0.875rem",
          fontWeight: 400,
          color: theme.palette.secondary,
          // Only apply transform for outlined variant
          "&.MuiInputLabel-outlined": {
            transform: "translate(14px, 10px) scale(1)",
            transition: "transform 200ms cubic-bezier(0.0,0,0.2,1) 0ms",
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -9px) scale(0.75)",
            },
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          color: theme.palette.common.black,
          //marginBottom: "8px",
        },
      },
    },

    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          "&.Mui-active": {
            fill: theme.palette.common.white,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          ".MuiInputAdornment-root": {
            marginBottom: "0px",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: "auto",
          fontSize: "0.875rem",
          padding: "2px",
          color: theme.palette.common.black,
          ".MuiSvgIcon-root": {
            color: alpha(theme.palette.common.black, 0.2),
          },
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          ".MuiButtonBase-root.Mui-selected": {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.light,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: `${theme.palette.common.white} !important`,
          color: `${theme.palette.common.black} !important`,
          backdropFilter: "blur(10px)",
        },
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[50],
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          ".MuiPaper-root": {
            color: theme.palette.common.white,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          ".MuiBackdrop-root": {
            backdropFilter: "blur(4px)",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: "60px",
          height: "30px",
          padding: "0px",
          ".MuiButtonBase-root": {
            padding: "2px",
            "&.Mui-checked": {
              webkitTransform: "translateX(30px)",
              mozTransform: "translateX(30px)",
              msTransform: "translateX(30px)",
              transform: "translateX(30px)",
              "+ .MuiSwitch-track": {
                backgroundColor: theme.palette.secondary.main,
                opacity: 1,
              },
            },
          },
          ".MuiSwitch-thumb": {
            width: "26px",
            height: "26px",
            backgroundColor: theme.palette.common.white,
          },
          ".MuiSwitch-track": {
            borderRadius: "50px",
            backgroundColor: theme.palette.grey[400],
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
              duration: theme.transitions.duration.shortest,
            }),
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          lineHeight: 1.5,
        },
        "*::-webkit-scrollbar": {
          width: "2px",
        },
        "*::-webkit-scrollbar:horizontal": {
          height: "4px", // Set horizontal scrollbar height
        },
        "*::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "*::-webkit-scrollbar-track:horizontal": {
          background: "#ddd", // Optional, for horizontal track
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: alpha(grey[600], 0.5),
          border: "2px solid transparent",
          borderRadius: "5px",
          width: "2px",
        },
        "*::-webkit-scrollbar-thumb:horizontal": {
          backgroundColor: alpha(grey[600], 0.5), // Or any color you want
          borderRadius: "5px",
          height: "4px", // Set horizontal thumb height
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: alpha(grey[600], 1),
        },
        "*::-webkit-scrollbar-thumb:horizontal:hover": {
          backgroundColor: alpha(grey[600], 1),
        },
      },
    },
  };
};

export default ComponentOverrides;

// Extend the Button's `variant` types
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    muted: true;
  }
  interface ButtonPropsVariantOverrides {
    muted: true;
  }
}
